import React from "react";
import PageHeader from "../components/PageHeader";
import Services from "../components/Services";
import WhyChoose from "../components/WhyChoose";
import Process from "../components/Process";
import useSEO from "../lib/seo";

export default function ServicesPage() {
  useSEO({
    title: "Services | Engineering, Architecture & Construction · LNZ Jamaica",
    description:
      "Full-service construction & development from LNZ: civil and structural engineering, architectural design, construction, project management, land development, quantity surveying, renovation and infrastructure.",
    path: "/services",
    keywords:
      "engineering services Jamaica, architectural design Caribbean, construction services Kingston, project management, quantity surveying Jamaica, land development, infrastructure engineering",
  });
  return (
    <div data-testid="services-page">
      <PageHeader
        overline="WHAT WE DO"
        title="Full-service construction "
        accent="& development."
        description="Eight integrated capabilities, one accountable partner. Every service is delivered by registered professionals and coordinated through a single project controls team."
      />
      <Services />
      <WhyChoose />
      <Process />
    </div>
  );
}
